import React from 'react';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import './style.scss';
import { Spinner } from 'react-bootstrap';
import Button from '../../../../components/molecules/buttons';
import RenderVMContainer, { VMContainerData } from '../utils/vm-container';

interface Props {
    sortedVM : VMContainerData[];
    isLoading: boolean;
    onNextVmConfig: () => void;
    onPreviousVmConfig: () => void;
    formik: any;
    handleChooseConfig: () => void;
    handleCurrentConfig: boolean;
}

const widthStyle : React.CSSProperties = { maxWidth: 380, width: '100%' };

function RenderVMConfig(props: Props) {
  const {
    sortedVM, isLoading, onNextVmConfig, onPreviousVmConfig,
    formik, handleChooseConfig, handleCurrentConfig,
  } = props;

  if (sortedVM && sortedVM.length) {
    return (
      <div>
        <div className="fz-16 fw-bold mb-4 ps-4 ps-xl-5">
          Machine Configuration
        </div>
        <div className="d-flex w-100 align-items-center justify-content-center">
          <ArrowCircleLeftIcon
            sx={{ fontSize: '30px' }}
            type="button"
            onClick={onPreviousVmConfig}
          />
          <RenderVMContainer data={sortedVM} />
          <ArrowCircleRightIcon
            sx={{ fontSize: '30px' }}
            type="button"
            onClick={onNextVmConfig}
          />
        </div>
        <div className="d-flex justify-content-center my-2">
          <div style={widthStyle}>
            <Button.Default
              id="chooseVMConfig"
              type="button"
              label={handleCurrentConfig ? 'Current Configuration' : 'Choose Configuration'}
              onClick={handleChooseConfig}
              outline={handleCurrentConfig}
              disabled={handleCurrentConfig}
              className={handleCurrentConfig ? 'fw-bold' : ''}
            />
            <div
              className={formik.touched.modelConfigId && !!formik.errors.modelConfigId ? 'invalidMsg mt-1' : 'd-none'}
            >
              {formik.errors.modelConfigId}
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="d-flex justify-content-center">
      {isLoading ? (
        <Spinner className="fz-14" animation="border" />
      ) : (
        <div className="text-center">Something went wrong</div>
      )}
    </div>
  );
}

export default React.memo(RenderVMConfig);
